import { setProgressPanelExpanded } from '../../../actions/WizardActions';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useEffect } from 'react';
import styled from 'styled-components';
import WizardProgressInfoPanel from '../../../components/Wizard/WizardProgressInfoPanel';
// @ts-expect-error Could not find a declaration file for module
import personImageUrl from 'bender-url!../../../../images/pngs/Jean_full.png';
import WizardActions from '../../../components/Wizard/WizardActions';
import WizardCategories from '../../../components/Wizard/WizardCategories';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useDispatch } from 'react-redux';
import WizardTools from '../../../components/Wizard/WizardTools';
import WizardTitle from '../../../components/Wizard/WizardTitle';
import UsageTracker from '../../../utils/UsageTracker';
import { useHistory } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { SCREENS } from '../../../constants/Tracking';
import { useCurrentLearningInterest, useSubmitWizardResults, useWizardProgress } from '../wizardQueries';
import { WizardLanguageToggle } from './WizardLanguageToggle';
import WizardResults from './WizardResults';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useWizardResults } from '../wizardHooks';
import WizardChooseMotivation from './WizardChooseMotivation';
import { useWizardNavigation } from '../wizardRouting';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { EditorPage } from 'foundations-components/transitional/components/EditorPage';
import { View } from 'foundations-components/transitional/components/View';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { Image } from 'foundations-components/transitional/components/Image';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubspotUILogoContainer = styled(FormattedReactMessage).withConfig({
  displayName: "WizardPage__HubspotUILogoContainer",
  componentId: "sc-1l5ls21-0"
})(["display:flex;flex:1;align-items:end;gap:8px;"]);
export const WizardPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    isMobile
  } = useMediaQuery();
  const {
    goForward,
    goBack
  } = useWizardNavigation();
  const {
    wizardProgress,
    currentStep
  } = useWizardProgress();
  const isFinalStep = currentStep === 'final';
  const hideProgress = currentStep === 'initial';
  const learningInterest = useCurrentLearningInterest();
  const {
    searchResults,
    resultsCount,
    isRequesting,
    selectedCategoryGroup,
    selectedToolsGroup,
    isToolsSelected,
    resultsUrl,
    searchCriteria,
    correlationId
  } = useWizardResults(learningInterest);
  const backClick = () => {
    goBack();
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-back'
    });
  };
  useSubmitWizardResults({
    resultCount: resultsCount,
    wait: isRequesting
  });
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.WIZARD
    });
  }, []);
  const closeWizard = () => {
    history.push('/');
  };
  const setCertsOnly = certsOnly => {
    goForward(certsOnly);
  };
  const openProgressPanelMobile = () => {
    dispatch(setProgressPanelExpanded(true));
  };
  const onClickProgressPanel = () => {
    dispatch(setProgressPanelExpanded(false));
  };
  const onClickCancel = () => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-cancel'
    });
    closeWizard();
  };
  const renderProgressPanel = () => {
    return /*#__PURE__*/_jsx(WizardProgressInfoPanel, {
      isRequesting: isRequesting,
      languageToggle: /*#__PURE__*/_jsx(WizardLanguageToggle, {
        showMoreContentInEnglishTooltip: resultsCount > 0 || isRequesting ? undefined : true
      }),
      onSetExpanded: expand => dispatch(setProgressPanelExpanded(expand)),
      onStepClick: onClickProgressPanel,
      resultsCount: resultsCount
    });
  };
  const renderWizardResults = () => {
    return /*#__PURE__*/_jsx(WizardResults, {
      catalogUrl: resultsUrl,
      correlationId: correlationId,
      isRequesting: isRequesting,
      onOpenResultsClick: openProgressPanelMobile,
      results: searchResults,
      totalResultCount: resultsCount
    });
  };
  const renderWizardMotivation = () => {
    return /*#__PURE__*/_jsx(WizardChooseMotivation, {
      isRequesting: isRequesting,
      onMotivationClick: setCertsOnly,
      resultCountTotal: resultsCount,
      searchCriteria: searchCriteria
    });
  };
  const onSelectOption = option => {
    goForward(option);
  };
  const renderCategories = () => {
    return isToolsSelected ? /*#__PURE__*/_jsx(WizardTools, {
      onOptionSelect: onSelectOption
    }) : /*#__PURE__*/_jsx(WizardCategories, {
      onOptionSelect: onSelectOption
    });
  };
  const renderWizardLeftContent = () => {
    if (isMobile) return null;
    if (hideProgress) {
      return /*#__PURE__*/_jsx(View, {
        inlineSize: "350px",
        children: /*#__PURE__*/_jsx(Image, {
          "data-test-id": "wizard-left-image",
          margin: "0",
          src: personImageUrl
        })
      });
    }
    return renderProgressPanel();
  };
  const renderWizardRightContent = () => {
    switch (currentStep) {
      case 'final':
        return renderWizardResults();
      case 'motivation':
        return renderWizardMotivation();
      default:
        return renderCategories();
    }
  };
  const renderResultsHelperText = () => {
    return isFinalStep && resultsCount > 0 ? /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.wizard.modal.refineresults"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.wizard.modal.savecourses"
      })]
    }) : null;
  };
  const renderLogo = () => {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      flex: 0,
      paddingBlockStart: "500",
      paddingInline: "1000",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-500",
        children: /*#__PURE__*/_jsx(HubspotUILogoContainer, {
          message: "learningCenter.wizard.logo",
          options: {
            imageElement: /*#__PURE__*/_jsx(Logo, {
              inlineSize: "106px",
              name: "hubspot-wordmark"
            })
          }
        })
      })
    });
  };
  const renderWizardTitle = () => {
    return /*#__PURE__*/_jsx(WizardTitle, {
      catGroup: isToolsSelected ? selectedToolsGroup : selectedCategoryGroup,
      isMobile: isMobile
    });
  };
  const hideTitle = isFinalStep && resultsCount < 1;
  return /*#__PURE__*/_jsx(EditorPage, {
    headerComponent: null,
    mainSectionFlush: true,
    scrollDirection: "none",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "stretch",
      blockSize: "100%",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "WIZARD_VIEW_LOADED"
      }), /*#__PURE__*/_jsx(View, {
        marginInline: "-100",
        children: /*#__PURE__*/_jsx(Progress, {
          "data-test-id": "wizard-progress-bar",
          marginBlock: "0",
          use: isFinalStep ? 'success' : 'warning',
          value: wizardProgress
        })
      }), isMobile && !hideProgress && renderProgressPanel(), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "stretch",
        flex: 1,
        flexDirection: "column",
        overflow: "auto",
        children: [!isMobile && renderLogo(), /*#__PURE__*/_jsx(WizardActions, {
          catalogUrl: resultsUrl,
          onBackLinkClick: backClick,
          onCancelClick: onClickCancel,
          totalResultCount: resultsCount
        }), /*#__PURE__*/_jsxs(View, {
          padding: isMobile ? '300' : '500',
          children: [/*#__PURE__*/_jsxs(Flex, {
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '0' : '800',
            children: [/*#__PURE__*/_jsx(Box, {
              basis: 0,
              grow: 1,
              children: /*#__PURE__*/_jsx(Flex, {
                justifyContent: "end",
                paddingInlineEnd: isFinalStep ? '0' : '1400',
                children: /*#__PURE__*/_jsx(Box, {
                  children: renderWizardLeftContent()
                })
              })
            }), /*#__PURE__*/_jsxs(Box, {
              basis: 0,
              grow: isFinalStep ? 3 : 1,
              inlineSize: isMobile ? '100%' : undefined,
              minInlineSize: "0",
              textAlign: isMobile ? 'left' : undefined,
              children: [!hideTitle && renderWizardTitle(), renderWizardRightContent()]
            })]
          }), /*#__PURE__*/_jsx(TFlex, {
            justify: 'center',
            marginBlockStart: "500",
            children: /*#__PURE__*/_jsx(Box, {
              children: renderResultsHelperText()
            })
          })]
        })]
      })]
    })
  });
};
export default WizardPage;